import {GameColor} from '../../GameColor'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {UIGameCanvasController} from '../UIGameCanvasController'
import {PIXI} from '@colonist/pixi'
import {HideableEndGameSection} from './UIGameEndController'

export class UIGameEndShadeWithLineController implements HideableEndGameSection {
    readonly container: SectionBgView
    private readonly canvas: UIGameCanvasController

    constructor(canvas: UIGameCanvasController, y: number, h: number, container: SectionBgView) {
        this.canvas = canvas
        this.container = new SectionBgView(container.x, y, container.width, h, container, true)

        this.drawBottomHalfBgShadeStartLine()
        this.drawBottomHalfBgShade()
    }

    private drawBottomHalfBgShadeStartLine() {
        const tabButtonsUnderlineAttributes = {
            height: this.canvas.appH / 400,
            alpha: 0.3,
            color: GameColor.getColorHexValue(GameColor.Color.GrayScale21),
        }
        const underline = new PIXI.Graphics()

        underline.lineStyle(tabButtonsUnderlineAttributes.height, tabButtonsUnderlineAttributes.color, tabButtonsUnderlineAttributes.alpha)
        underline.lineTo(this.container.width, 0)
        this.container.addChild(underline)
    }

    private drawBottomHalfBgShade() {
        const backgroundShade = new SectionBgView(0, 0, this.container.width, this.container.height, this.container)
        backgroundShade.drawBg()
        backgroundShade.bg.alpha = 0.4
    }

    hide(): void {
        this.container.visible = false
    }

    show(): void {
        this.container.visible = true
    }
}
